import { render, staticRenderFns } from "./IconPhoneMissedCallSolid.vue?vue&type=template&id=23bd7e89"
import script from "./IconPhoneMissedCallSolid.vue?vue&type=script&lang=js"
export * from "./IconPhoneMissedCallSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports